import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';

export default function AboutUsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-16">
        {/* Page Title */}
        <div className="mb-12">
          <h1 className="text-4xl font-bold text-gray-900">About Us</h1>
        </div>

        
       

        {/* Divider */}
        <div className="border-t border-gray-300 mb-12"></div>

        {/* Company History Section */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <div className="mb-8">
            <img 
                          src="/images/lagoos.png" 
              alt="Arrow" 
              className="w-40 h- mx-auto"
            />
          </div>

          <div className="space-y-6 text-gray-700 text-base leading-relaxed">
            <p>
              The AgriWorks was invented in 1992. It was developed to solve the age-old problem of trimming hard to reach tree branches and unwanted trees. The tree shear design was made to eliminate the unsafe practice of trimming limbs with a chain saw from a loader bucket or ladder.
            </p>

            

           

            <p>
              In addition to manufacturing tree shears, AgriWorks also manufactures a variety of grapples and tree pullers.
            </p>

            <p>
              AgriWorks uses only the finest quality of raw material and produces most of the components in house.
            </p>

            <p>
              The tree shears, grapples and tree pullers are used by professionals in addition to the many satisfied landowners. Has been used to clear hundreds of acres of land for golf courses. Several Federal, State, and City maintenance departments own and use the clipper. We have participated in hurricane, tornado, ice storms and other national disaster cleanups.
            </p>
          </div>
        </div>

        

        {/* Divider */}
        <div className="border-t border-gray-300 mb-12"></div>

        {/* Call to Action */}
        <div className="bg-white py-12 mb-12">
          <div className="text-center">
            <h3 className="text-3xl font-bold text-[#c41e3a] mb-4">
              SOLVING TREE & BRUSH PROBLEMS SINCE 1992!
            </h3>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-300 mb-12"></div>

        {/* Disclaimer */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h6 className="text-sm text-gray-600 leading-relaxed">
            All products have been carefully manufactured and tested. Should our product prove defective, or appear to be, please discontinue use immediately and contact us. Not responsible for any damage or claims beyond the selling price of the product. No returns allowed without express written consent of company.
          </h6>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#003d5c] text-white py-12" style={{
              backgroundImage: 'url(/images/scaled.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Logo and Company Info */}
            <div>
              <img 
                              src="/images/lagoos.png" 
                alt="AgriWorks Logo" 
                className="h-24 mb-4"
              />
              <h6 className="text-sm">
                Powered by AgriWorks<br />
               
                <a href="tel:6812968160" className="hover:underline">(681) 296-8160</a>
              </h6>
              
              
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-lg font-bold mb-4">Contact</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <a href="mailto:jolyn.consult@hotmail.com" className="hover:underline">
                    Email: jolyn.consult@hotmail.com
                  </a>
                </li>
                <li>
                  <a href="tel:6812968160" className="hover:underline">
                    Phone: (681) 296-8160
                  </a>
                </li>
                <li>23 Margaret Dr, Somerset, NJ 08873</li>
              </ul>
            </div>

            {/* Links */}
            <div>
              <h3 className="text-lg font-bold mb-4">Links</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/products" className="hover:underline">Products</Link>
                </li>
                
                <li>
                  <Link to="/contact" className="hover:underline">Contact Us</Link>
                </li>
                
              </ul>
            </div>

            {/* Made in USA Badge */}
            <div className="flex items-center justify-center">
              <img 
                              src="/images/made-in-the-usa.webp" 
                alt="Made in USA" 
                className="h-32"
              />
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
